<bt-barcode-design [model]="model" [value]="model.value"></bt-barcode-design>